import React from 'react';
import './app.scss';

const AuthorCard = ({author}) => {

  const authorString = JSON.stringify(author);
  let authorData = JSON.parse(authorString);

  authorData = JSON.parse(author);

  return (
    <div className="author-card-container">
      <div className="author-card">
        <div className="author-title">ABOUT THE AUTHOR</div>
        <div className="author-body">
          <img src={`${authorData.img}`} alt="" className="author-img" />
          <div className="author-details">
            <a className='a-d-name' href={`/author/${authorData.name.toLowerCase().replace(/ /g, '-')}/`}  target="_blank">
              {authorData.name} </a> 
            <div className="a-d-designation">{authorData.designation}</div>
            <span
              className="a-d-about"
            >{authorData.MetaDescription}...</span>
            <a className='author-readmore' href={`/author/${authorData.name.toLowerCase().replace(/ /g, '-')}/`}  target="_blank"
            > read more</a>

            <div className="author-sm-container">
              <a href={authorData.linkedin}> <img
                className="author-sm"
                src="https://s3.ap-south-1.amazonaws.com/testconvexstorage.kraftshala.com/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46nuyfe.webp"
              /></a>
              {authorData.X && <a href={authorData.X}><img
                className="author-sm"
                src="https://s3.ap-south-1.amazonaws.com/testconvexstorage.kraftshala.com/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46nybfv.webp"
              /></a>}
              <a href={authorData.instagram}><img
                className="author-sm"
                src="https://s3.ap-south-1.amazonaws.com/testconvexstorage.kraftshala.com/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46np6f5.webp"
              /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthorCard;